// Yetki kontrol fonksiyonları

export const hasPermission = (user, module, action) => {
  // Admin her şeye erişebilir
  if (user?.role === 'admin') {
    return true;
  }

  // Permissions yoksa false
  if (!user?.permissions) {
    return false;
  }

  // İlgili modül ve aksiyonu kontrol et
  return user.permissions[module]?.[action] === true;
};

export const canView = (user, module) => hasPermission(user, module, 'view');
export const canCreate = (user, module) => hasPermission(user, module, 'create');
export const canEdit = (user, module) => hasPermission(user, module, 'edit');
export const canDelete = (user, module) => hasPermission(user, module, 'delete');

// Modül ID'leri
export const MODULES = {
  DASHBOARD: 'dashboard',
  HOMEPAGE_LOGISTICS: 'homepage_logistics',
  HOMEPAGE_PRODUCTION: 'homepage_production',
  HOMEPAGE_STOCK_IN: 'homepage_stock_in',
  HOMEPAGE_STOCK_OUT: 'homepage_stock_out',
  HOMEPAGE_PROJECT: 'homepage_project',
  PROJECTS: 'projects',
  STOCK: 'stock',
  PRODUCTION: 'production',
  SHIPMENT: 'shipment',
  USERS: 'users'
};
